import Vue from 'vue'

export default {
  // changeActiveTab(state, tab){
  //   state.active_tab = tab;
  // },
  changeActiveTab(state, index){
    state.active_tab = state.product_tab.buttons[index].code;
    // ボタンの無効化を解除する
    Vue.set(state.product_tab.buttons, index, {...state.product_tab.buttons[index], 'disabled':false});
    state.product_tab.activeIndex = index+1;
  },
	/**
	 * 全ての中帯ボタンの無効化を解除する
	 * @param state
	 */
  clearActiveTab(state){ // オーダーNo.を読み込んだ時
    for (let i = 0; i < state.product_tab.buttons.length; i++) {
      Vue.set(state.product_tab.buttons, i, {...state.product_tab.buttons[i], 'disabled': false});
    }
  },
	disableAfterActiveTab(state, currentIndex=0){
		for (let i = 0; i < state.product_tab.buttons.length; i++) {
			if (i <= currentIndex) {
				Vue.set(state.product_tab.buttons, i, {...state.product_tab.buttons[i], 'disabled': false});
			} else {
				Vue.set(state.product_tab.buttons, i, {...state.product_tab.buttons[i], 'disabled': true});
			}
		}
	},
  addCart(state, cart) {
    // デザインIDを基準にしてカートを整理
    const existStockCart = state.stock_cart.find(stock_cart => {
      return stock_cart.design.id === cart.design.id
        // さらにカラー、オプションが完全に同一かチェック
        && stock_cart.parts === cart.parts && stock_cart.letters === cart.letters;
    });
    if (existStockCart) {
      Vue.set(state.stock_cart, state.stock_cart.indexOf(existStockCart), cart);
    } else {
      state.stock_cart.push(Object.assign({}, cart));
    }
    localStorage.setItem('stock_cart', JSON.stringify(state.stock_cart));
  },
  resetCartStock (state) {
    state.stock_cart = [];
    localStorage.setItem('stock_cart', JSON.stringify(state.stock_cart));
  },
  resetCart (state) {
    state.cart = {
      number: null,
        category: null,
        parts: [],
        letters: [],
        packs: [
        {
          size_name: null,
          size_id: "",
          value: null,
          number: "",
          name: null,
          pack_price: null,
        }
      ],
        figure: null,
        design: null,
        order: {
        email: null,
          name: null,
          zip: null,
          address: null,
          street: null,
          tel: null,
          comment: null,
      }
    };
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartJson(state, cart){
    state.cart = Object.assign(state.cart, cart);
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartCategory(state, category){
    state.cart.category = category;
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartFigure(state, figure){
    state.cart.figure = figure;
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartDesign(state, design){
    state.cart.design = design;
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  clearCategory(state) {
    state.cart.category = null;
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
	clearDesign(state){
		state.cart.design = null;
    localStorage.setItem('cart', JSON.stringify(state.cart));
	},
	clearFigure(state){
		state.cart.figure = null;
    localStorage.setItem('cart', JSON.stringify(state.cart));
	},
  clearLetters(state){
    state.cart.letters = [];
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
	clearParts(state){
		state.cart.parts = [];
    localStorage.setItem('cart', JSON.stringify(state.cart));
	},
  clearPacks(state){
    state.cart.packs = [
      {
        size_name: null,
        size_id: "",
        value: null,
        number: "",
        name: null,
        pack_price: null,
      }
    ];
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartParts(state, parts){
    state.cart.parts = parts;
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartLetters(state, letters){
    state.cart.letters = letters;
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartPack(state, payload){
    Vue.set(state.cart.packs, payload.index, payload.pack)
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  addCartPack(state, pack){
    state.cart.packs.push(pack);
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  deleteCartPack(state, pack){
    if (state.cart.packs.length > 1){
      state.cart.packs.splice(state.cart.packs.indexOf(pack), 1);
    }
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartNumber(state, number){
    state.cart.number = number;
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setWord(state, payload){
    for (let i = 0; i < state.cart.letters.length; i++) {
      if (state.cart.letters[i].id == payload.letter_id) {
        Vue.set(state.cart.letters, i, {...state.cart.letters[i], 'word':payload.word});
      }
    }
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setFonts(state, fonts){
    state.fonts = fonts;
  },
  setDecoration(state, payload){
    if (payload.decoration.color_id){
      for (let i = 0; i < payload.decoration.color_group.colors.length; i++) {
        if (payload.decoration.color_group.colors[i].id == payload.decoration.color_id){
          payload.decoration.color = payload.decoration.color_group.colors[i];
          break;
        }
      }
    }
    if (payload.decoration.outline_color_id){
      for (let i = 0; i < payload.decoration.color_group.colors.length; i++) {
        if (payload.decoration.color_group.colors[i].id == payload.decoration.outline_color_id) {
          payload.decoration.outline_color = payload.decoration.color_group.colors[i];
          break;
        }
      }
    }
    for (let i = 0; i < state.cart.letters.length; i++) {
      if (state.cart.letters[i].id == payload.letter_id) {
        // let stock_cart = state.stock_cart.find(stock_cart => stock_cart.design.id === state.cart.design.id);
        // console.log(stock_cart);
        Vue.set(state.cart.letters, i, {...state.cart.letters[i], 'decoration':payload.decoration});
      }
    }
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartLetterFont(state, [letter, font] = []){
    let found = false;
    for (let i = 0; i < state.cart.letters.length; i++) {
      if (state.cart.letters[i].id === letter.id) {
        Vue.set(state.cart.letters, i, {...state.cart.letters[i], 'font':font});
        found = true;
      }
    }
    if (!found){
      letter.font = font;
      state.cart.letters.push(letter);
    }
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartLetterPicture(state, [letter, picture] = []){
    let found = false;
    for (let i = 0; i < state.cart.letters.length; i++) {
      if (state.cart.letters[i].id === letter.id) {
        Vue.set(state.cart.letters, i, {...state.cart.letters[i], 'picture':picture});
        found = true;
      }
    }
    if (!found){
      letter.picture = picture;
      state.cart.letters.push(letter);
    }
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setCartLetterColor(state, payload){
    for (let i = 0; i < state.cart.letters.length; i++) {
      if (state.cart.letters[i].id == payload.selectedLetter.id) {
        if (payload.decoration_part.name == '縁取り'){
          Vue.set(state.cart.letters[i], 'decoration', {...state.cart.letters[i].decoration, 'outline_color':payload.color});
        } else {
          Vue.set(state.cart.letters[i], 'decoration', {...state.cart.letters[i].decoration, 'color':payload.color});
        }
      }
    }
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setPartColor(state, payload){
    for (let i = 0; i < state.cart.parts.length; i++) {
      if (state.cart.parts[i].id == payload.part.id) {
        state.cart.parts[i].designs_part.color = payload.color;
      }
    }
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  setOrder(state, order){
    // state.cart.order.email = input.email;
    // state.cart.order.name = input.name;
    // state.cart.order.zip = input.zip;
    // state.cart.order.address = input.address;
    // state.cart.order.street = input.street;
    // state.cart.order.tel = input.tel;
    // state.cart.order.comment = input.comment;

    state.order = order;
  },
  setLoading(state){
    state.loading = true;
  },
  resetLoading(state){
    state.loading = false;
  },
  setPage(state, page){
    state.page = page;
  },
  setReverse(state, reverse){
    state.reverse = reverse;
  },
  setPackNumber(state, word){
    Vue.set(state.cart.packs[0], 'number', word);
  },
  setPackName(state, word){
    Vue.set(state.cart.packs[0], 'name', word);
  },
  setStockCart(state, stockCart){
    state.stock_cart = stockCart;
    localStorage.setItem('stock_cart', JSON.stringify(state.stock_cart));
  },
  resetStockCart (state) {
    state.stock_cart = [];
    localStorage.setItem('stock_cart', JSON.stringify(state.stock_cart));
  },
  setStockCartPack(state, payload) {
    const cart = payload.cart;
    const pack = payload.pack;
    const index = payload.index;
    let stock_cart = state.stock_cart.find(stock_cart => stock_cart === cart);
    stock_cart.packs.splice(Number(index), 1, pack);
    localStorage.setItem('stock_cart', JSON.stringify(state.stock_cart));
  },
  removeCartPack(state, cart, pack) {
    const stock_cart = state.stock_cart.find(stock_cart => stock_cart === cart);
    if (stock_cart.packs.length > 1) {
      stock_cart.packs.splice(stock_cart.packs.indexOf(pack), 1);
    } else {
      state.stock_cart.splice(state.stock_cart.indexOf(cart), 1);
    }
    localStorage.setItem('stock_cart', JSON.stringify(state.stock_cart));
  },
  openModal(state, modal){
    state.modals.push(modal);
  },
  closeModal(state){
    state.modals.pop();
  },
  setSizes(state, sizes){
    if (sizes.length) {
      const figure_id = sizes[0].figure_id;
      Vue.set(state.sizes, figure_id, sizes);
    }
  }
}
